import React, { useContext, useEffect, useState } from "react";
import Media from 'react-media';

import { PartWrapper } from "./styled";
import {
    CostInput,
    NumberInput,
    TextAreaInput,
    TextInput,
    SelectPart
} from "components";
import { ReactComponent as TrashIcon } from "assets/svgs/trash.svg";
import { ReactComponent as DraggableIcon } from "assets/svgs/draggable.svg";
import { AppContext } from "hocs/withAppContext";
import { Draggable } from "react-beautiful-dnd";

export const PartRow = ({ index, part, updatePart, deletePart }) => {
    const { role } = useContext(AppContext);
    const { currencyDictionary } = role;

    const currencySymbol = currencyDictionary ?
        currencyDictionary.symbol : '$';

    // data to be pre-filled if existing
    // part is being added
    const [data, setData] = useState({
        name: '',
        description: '',
        cost: 0,
        quantity: 1
    });
    const price = (data.quantity || 0) * (data.cost || 0);

    useEffect(() => {
        updatePart({
            ...part,
            _price: price,
            data,
        });
    // eslint-disable-next-line
    }, [data]);

    return <>
        <div className="container">
            <Media query={{ maxWidth: 768 }}>
                {matches => matches ? <span>#</span> : null}
            </Media>
            <span>{index + 1}</span>
        </div>
        <div className="container">
            <Media query={{ maxWidth: 768 }}>
                {matches => matches ? <span>Name</span> : null}
            </Media>
            { !part._existing &&
            <TextInput
                placeholder="Part Name"
                value={data.name}
                onChange={val => setData({ ...data, name: val })}
            /> }
            { part._existing &&
            <SelectPart
                placeholder="Part Name"
                value={data}
                onChange={(part, action) => setData({
                    ...data,
                    ...part,
                    name: part ? part.stringPartName: '',
                    description: part ? (part.stringPartDescription || ''): '',
                    cost: part ? (part.numberPartCost || 0): 0,
                })}
            />}
        </div>
        <div className="container">
            <Media query={{ maxWidth: 768 }}>
                {matches => matches ? <span>Cost</span> : null}
            </Media>
            <CostInput
                placeholder="0"
                value={data.cost}
                onChange={val => setData({ ...data, cost: val })}
                disabled={part._existing}
            />
        </div>
        <div className="container">
            <Media query={{ maxWidth: 768 }}>
                {matches => matches ? <span>Quantity</span> : null}
            </Media>
            <NumberInput
                placeholder="0"
                value={data.quantity}
                onChange={val => setData({ ...data, quantity: val })}
            />
        </div>
        <div className="container">
            <Media query={{ maxWidth: 768 }}>
                {matches => matches ? <span>Description</span> : null}
            </Media>
            <TextAreaInput
                placeholder="Description"
                rows={1}
                value={data.description}
                onChange={val => setData({ ...data, description: val })}
                disabled={part._existing}
            />
        </div>
        <div className="container">
            <Media query={{ maxWidth: 768 }}>
                {matches => matches ? <span>Price</span> : null}
            </Media>
            <span>{currencySymbol} {price}</span>
        </div>
        <div className="container">
            <TrashIcon onClick={deletePart}/>
            <DraggableIcon/>
        </div>
    </>
};


export const PartRowDroppable = props => {
    return <Draggable
        index={props.index}
        draggableId={String(props.part._id)}
    >
        {(provided, snapshot) =>
            <PartWrapper
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                dragging={snapshot.isDragging}
            >
                <PartRow {...props}/>
            </PartWrapper>
        }

    </Draggable>
};

export default PartRowDroppable;
